<template>
    <section class="main-page">
        <slot></slot>
        <div v-if="loading" class="main-loading">
            <div class="lds-ripple"><div></div><div></div></div>
            <div class="">{{["Loading please wait...", "Chargement, veuillez patienter..."] | tr}}</div>
        </div>

        <app-footer></app-footer>
    </section>
</template>

<script>
    import Footer from './app-footer'

    export default {
        name: `main-page`,
        components: {'app-footer': Footer},
         props: [`propertiesPanel`, `loading`]
    }
</script>

<style lang="scss" scoped>
    //@import "assets/style/global.scss";
    @import "../assets/style/bootstrap-theme.scss";

.main-page {
        position: relative;
        width: 100%;
    }

    .content {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: row;

        > .tabs {
            width: 100%;
            min-width: 320px;
            padding: 30px;
            height: 100%;
            position: relative;

            &::v-deep .tab-content {
                height: 100%;

                .tab-pane {
                    height: 100%;
                }
            }
        }

        &.max-1600 {
            margin-left: auto;
            margin-right: auto;
            max-width: 1600px;
        }

        &.max-1440 {
            margin-left: auto;
            margin-right: auto;
            max-width: 1440px;
        }

        &.max-1280 {
            margin-left: auto;
            margin-right: auto;
            max-width: 1280px;
        }

        &.max-1024 {
            margin-left: auto;
            margin-right: auto;
            max-width: 1024px;
        }

        &.max-768 {
            margin-left: auto;
            margin-right: auto;
            max-width: 768px;
        }
    }

    .card-container {
        margin: 10px 30px;
    }

    .jumbotron {
        position: relative;
        background-color: #ffffff;
        color: #666;
        padding: 35px;

        .jumbotron-icon {
            position: absolute;
            top: 15px;
            right: 15px;
            width: 48px;
        }
    }

    .main-loading {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        background-color: rgba(0, 0, 0, 0.25);
        pointer-events: all;
        text-align: center;
        padding-top: 20%;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-size: 9pt;

        .lds-ripple {
            display: inline-block;
            position: relative;
            width: 64px;
            height: 64px;
        }
        .lds-ripple div {
            position: absolute;
            border: 4px solid #fff;
            opacity: 1;
            border-radius: 50%;
            animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
        }
        .lds-ripple div:nth-child(2) {
            animation-delay: -0.5s;
        }
        @keyframes lds-ripple {
            0% {
                top: 28px;
                left: 28px;
                width: 0;
                height: 0;
                opacity: 1;
            }
            100% {
                top: -1px;
                left: -1px;
                width: 58px;
                height: 58px;
                opacity: 0;
            }
        }
    }

    @media(min-width: 600px) and (max-width: 1368px) {
        .content {
            > .tabs {
                padding: 15px;
            }
        }
    }

    @media(max-width: 600px) {
        .content {
            > .tabs {
                padding: 10px;
            }
        }
        .card-container {
            margin: 0 10px;
        }
    }
</style>
